import { endPoints } from "@/constants/apiSetting";
import httpClient from "@/common/service/HttpClient";
const InviteNewCandidateService = {
  getCandidateInvitedList(obj) {
    return httpClient.post(endPoints.getCandidateInvitedList, obj);
  },
  getCandidateInvited(obj) {
    return httpClient.post(endPoints.getCandidateInvited, obj);
  },
  getCandidateInvitedByCandIdAndJobAdcode(obj) {
    return httpClient.post(endPoints.getCandidateInvitedByCandIdAndJobAdcode, obj);
  },
  getAllCandidateInvitedListByCandid(obj) {
    return httpClient.post(endPoints.getallcandidateinvitedlistbycandid, obj);
  },
  getAllCandidateInvitedByNameMobileKeyWord(obj) {
    return httpClient.post(endPoints.getAllCandidateInvitedByNameMobileKeyWord, obj);
  },
  getAllCandidateInvitedList(obj) {
    return httpClient.post(endPoints.getAllCandidateInvitedList, obj);
  },
  getCandidateDetailByCandIdAndJobAdcode(obj) {
    return httpClient.post(endPoints.getCandidateDetailByCandIdAndJobAdcode, obj);
  },
  getCandidateInvitedDetailByCandId(obj) {
    return httpClient.post(endPoints.getCandidateInvitedDetailByCandId, obj);
  },
  validateToken(obj) {
    return httpClient.post(endPoints.validateToken, obj);
  },
  verifyCandidate(obj) {
    return httpClient.post(endPoints.verifyCandidate, obj);
  },
  add(obj) {
    return httpClient.post(endPoints.addCandidateInvited, obj);
  },
  update(obj) {
    return httpClient.post(endPoints.updateCandidateInvitedUpdate, obj);
  },
  updateJobApplication(obj) {
    return httpClient.post(endPoints.updateJobApplication, obj);
  },
  updateCandidateJobApplication(obj) {
    return httpClient.post(endPoints.updateCandidateJobApplication, obj);
  },
  checkInterviewerPwd(obj) {
    return httpClient.post(endPoints.checkInterviewerPwd, obj);
  },
};

export default InviteNewCandidateService;



// WEBPACK FOOTER //
// ./src/service/InviteNewCandidateService.js